module.exports = __webpack_public_path__ + "img/cosleep_guidance_img_subscribe3_cn@3x.e8310f20.png";